
<compliance-graph [graph]="graphBlock"></compliance-graph>
